import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchFilter, IFilterResponse } from 'src/app/infrastructure/iFilter-component';
import { MatTableDataSource, MatSort } from '@angular/material';
import { SearchCompleteFilterComponent } from '../../controls/search-complete-filter/search-complete-filter.component';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { Router } from '@angular/router';
import { MenuService } from 'src/app/services/menu.service';
import { OrientationSearchItem } from '../../../model/orientation/orientation-search-item';

@Component({
  selector: 'app-orientation-search',
  templateUrl: './orientation-search.component.html',
  styleUrls: ['./orientation-search.component.css']
})
export class OrientationSearchComponent implements OnInit {

  loading: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];
  widthTableExp: number;
  displayedColumns: string[] = ['name', 'star'];
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchCompleteFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor(
    private router: Router
    , private menuService: MenuService) {
    this.menuService.setMenuTitle('Orientador', 'admisión orientador');
  }

  ngOnInit(): void {

  }

  startCaller(orientationSearchItem: OrientationSearchItem): void {
      this.router.navigate(['patient-orientation', orientationSearchItem.Id]);
  }

  onStartSearch(): void {
    this.loading = true;
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<OrientationSearchItem>): void {
    this.searchFilters = response.searchFilters;
    this.pager.setItems(response.items);
  }
}
